import { UnitPlanPromptNames } from '@lessonPlanner/constants';

export function getFirstGradeLevelForCurriculum(
  curriculum: UnitPlanPromptNames,
): string {
  switch (curriculum) {
    case UnitPlanPromptNames.PYP:
      return 'Kindergarten';
    case UnitPlanPromptNames.MYP:
      return 'Grade 6';
    case UnitPlanPromptNames.DP:
      return 'Grade 11';
    default:
      return 'Kindergarten';
  }
}
